export const INITIAL_ASSIGNMENT_NOTIFICATION_SHOWN =
  'INITIAL_ASSIGNMENTS_NOTIFICATION_SHOWN';

export const LAST_SELECTED_TEACHER_CLASS_ID = 'LAST_SELECTED_TEACHER_CLASS';

export const SCHEDULED_ASSIGNMENTS_EVENTS = 'SCHEDULED_ASSIGNMENTS_EVENTS';

export const GATEWAY_URL_LS_KEY = 'ampConfig.gateway';
